import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DataLayerModule } from '../../common/datalayer/datalayer.module';
import { GenerateClassPipe } from '../../pipes/generate-class.pipe';
import { FooterColumnComponent } from './footer-column.component';

@NgModule({
  imports: [CommonModule, DataLayerModule, BsDropdownModule.forRoot()],
  declarations: [FooterColumnComponent, GenerateClassPipe],
  exports: [FooterColumnComponent]
})
export class FooterColumnModule {}
